export const version = "properties/5.4.0";
//# sourceMappingURL=_version.js.map